'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiGift = function TiGift(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 13.3h-4c0.4-0.7 0.6-1.6 0.6-2.5 0-3.2-2.6-5.8-5.8-5.8-1.6 0-3.1 0.7-4.2 1.8-1-1.1-2.5-1.8-4.1-1.8-3.3 0-5.9 2.6-5.9 5.8 0 0.9 0.3 1.8 0.6 2.5h-3.9c-0.9 0-1.7 0.8-1.7 1.7v6.7c0 0.9 0.8 1.6 1.7 1.6v8.4c0 2.7 2.2 5 5 5h16.7c2.7 0 5-2.3 5-5v-8.4c0.9 0 1.6-0.7 1.6-1.6v-6.7c0-0.9-0.7-1.7-1.6-1.7z m-1.7 6.7h-8.3v-3.3h8.3v3.3z m-13.3-8.3h3.3v1.6h-3.3v-1.6z m3.3 5v3.3h-3.3v-3.3h3.3z m2.5-8.4c1.4 0 2.5 1.2 2.5 2.5s-1.1 2.5-2.5 2.5c-0.3 0-0.6 0-0.8-0.1v-1.5c0-0.9-0.7-1.6-1.6-1.7 0.4-1 1.3-1.7 2.4-1.7z m-10.8 2.5c0-1.3 1.1-2.5 2.5-2.5 1.1 0 2 0.7 2.3 1.7-0.8 0.1-1.5 0.8-1.5 1.7v1.5c-0.3 0.1-0.5 0.1-0.8 0.1-1.4 0-2.5-1.1-2.5-2.5z m3.3 5.9v3.3h-8.3v-3.3h8.3z m-5 16.6c-0.9 0-1.7-0.7-1.7-1.6v-10h6.7v11.6h-5z m6.7 0v-11.6h3.3v11.6h-3.3z m10 0h-5v-11.6h6.6v10c0 0.9-0.7 1.6-1.6 1.6z' })
        )
    );
};

exports.default = TiGift;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/gift.js
// module id = 3610
// module chunks = 0